import { Alert, AlertDescription } from "@/components/ui/alert";
import { useTranslation } from "@/hooks/useTranslation";
import { AlertTriangleIcon } from "lucide-react";

/**
 * A tab with nothing to show because a section it is filled from failed: it
 * says the data could not be read, never that the company has none.
 */
export default function CompanyTabReadFailed() {
  const { t } = useTranslation();

  return (
    <Alert variant="warning">
      <AlertTriangleIcon />
      <AlertDescription className="text-current">
        {t("company.tabs.readFailed")}
      </AlertDescription>
    </Alert>
  );
}
